import type { ElementType, HTMLAttributes, ReactNode } from "react";
import { BackgroundPatternType } from "@/components/atoms/BackgroundPattern";
import { ContentImage, ContentVideo } from "@/content/types";

export const SECTION_CONTAINER_WIDTHS = {
  container: "container",
  "max-w-7xl": "max-w-7xl",
  "max-w-4xl": "max-w-4xl",
  "max-w-full": "max-w-full",
} as const;

export type SectionContainerWidth = keyof typeof SECTION_CONTAINER_WIDTHS;

/** @deprecated Use SectionBackgroundProps + SectionContentProps instead */
export type SectionShellProps = {
  as?: ElementType;
  className?: string;
  containerClassName?: string;
  containerSize?: SectionContainerWidth;
  contained?: boolean;
  wrapContainer?: boolean;
  wrapperProps?: HTMLAttributes<HTMLElement> &
    Record<string, string | undefined>;
  backgroundColor?: string;
  backgroundImage?: ContentImage;
  backgroundVideo?: ContentVideo;
  backgroundPattern?: BackgroundPatternType;
  patternOpacity?: number | null;
  isDark?: boolean;
  /** Enable priority loading for above-the-fold hero sections */
  priority?: boolean;
  children: ReactNode;
};
